module.exports = __webpack_public_path__ + "img/Title_kuraray2.d9351b0a.png";